export const HOMEOWNERS_FORMTYPE = "Homeowners";
export const DWELLING_FORMTYPE = "Dwelling";
export const BOP_FORMTYPE = "Business Owner";
export const LANDLORD_FORMTYPE = "Landlord";

export const PRODUCT_TYPE_PREFIXES_TO_FORMTYPE = {
  LL: LANDLORD_FORMTYPE,
  BOP: BOP_FORMTYPE,
  DP: DWELLING_FORMTYPE
};

// These are special enumerations in Widen meta vocabulary
export const NOT_ROLE_SPECIFIC = "Not role specific";
export const NOT_STATE_SPECIFIC = "Not state specific";

// Form search
export const SEARCH_PLACEHOLDER = "Search form names or numbers";
export const SEARCH_TRACKING_TAG = "Resources search text";

// Filename masking
export const FILENAME_MASKING_DELIMS = {
  QRG: "QRG",
  OVERVIEW: "Overview"
};

export const RESOURCE_BUCKET_TYPES = {
  UW_OVERVIEWS: "Underwriting Overviews",
  PRODUCT_HIGHLIGHTS: "Product Highlights"
};
